import { Map } from 'immutable';
import { ApiResponseHelper } from 'omni-common-ui';

import {
  FETCH_READER_RESULTS_REQUEST,
  FETCH_READER_RESULTS_SUCCESS,
  FETCH_READER_RESULTS_FAILURE,
} from './actions';
import Reader from './model';

export default function readerReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_READER_RESULTS_REQUEST:
      return ApiResponseHelper.create({ loading: true });
    case FETCH_READER_RESULTS_SUCCESS:
      return ApiResponseHelper.create(Reader.create(action.payload));
    case FETCH_READER_RESULTS_FAILURE:
      return ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/Reader/reducer.js